
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface AuthRequiredProps {
  title?: string;
  description?: string;
  showBrowseProducts?: boolean;
  className?: string;
}

const AuthRequired = ({
  title,
  description,
  showBrowseProducts = true,
  className = '',
}: AuthRequiredProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  
  const currentPath = encodeURIComponent(location.pathname + location.search);
  const loginUrl = `/login?redirect=${currentPath}`;

  return (
    <div className={`min-h-screen bg-gray-50 pt-24 pb-12 ${className}`}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          {/* Icon */}
          <div className="w-20 h-20 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-6">
            <i className="ri-lock-line text-4xl text-teal-600"></i>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            {title || t('auth.required_title')}
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-8">
            {description || t('auth.required_description')}
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={loginUrl}
              className="px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium whitespace-nowrap flex items-center justify-center"
            >
              <i className="ri-login-box-line mr-2"></i>
              {t('nav.login')}
            </a>
            
            {showBrowseProducts && (
              <a
                href="/products"
                className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:border-teal-600 hover:text-teal-600 transition-colors font-medium whitespace-nowrap flex items-center justify-center"
              >
                <i className="ri-shopping-bag-line mr-2"></i>
                {t('common.actions.browse_products')}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthRequired;
